import axios from 'axios';
import { toast } from 'react-toastify';
import { config } from '../../../../config/envs';

const ADMIN_BASE_URL = config.app.adminBaseUrl;

export class PlansAPI {
  static async list({ page = 0, limit = 100, active = true, name } = {}) {
    try {
      const params = new URLSearchParams();
      if (name) params.append('name', name);
      if (active !== undefined) params.append('active', active);
      params.append('page', page);
      params.append('limit', limit);
      const response = await axios.get(
        `${ADMIN_BASE_URL}/v2/plans?${params.toString()}`,
      );
      return response;
    } catch (error) {
      toast.error('Não foi possível buscar os planos');
      throw error;
    }
  }

  static async get(id) {
    const response = await axios.get(`${ADMIN_BASE_URL}/v2/plans/${id}`);
    return response;
  }
}
